import type { FooterContent } from "../types";
import { renderLogo } from "./logo";

/** 页脚：多栏分类链接 + 品牌行 + 法务行（参考 about.google 页脚结构） */
export function renderFooter(footer: FooterContent): string {
  const columns = footer.columns
    .map(
      (col) => `
      <div class="footer-col">
        <h4>${col.title}</h4>
        ${col.links.map((l) => `<a href="${l.href}">${l.label}</a>`).join("")}
      </div>`,
    )
    .join("");

  const legal = footer.legal
    .map((l) => `<a href="${l.href}">${l.label}</a>`)
    .join("");

  return `
    <footer>
      <div class="footer-cols">
        <div class="footer-brand">
          ${renderLogo("mark")}
          <span>${footer.tagline}</span>
        </div>
        ${columns}
      </div>
      <div class="footer-legal">
        <span>${footer.copyright}</span>
        <div class="footer-legal-links">${legal}</div>
      </div>
    </footer>`;
}
